var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcosystemUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ecosystem-list",
    transform: "translate(-937.000000, -432.000000)",
    stroke: "#6D8994"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M949.25,445.36 C949.25,445.36 948.79,446.36 946.06,446.42 C946.06,446.42 944.34,446.48 943.9,446.42 C943.5,446.42 941.72,446.42 941.72,446.42 C939,446.32 938.53,445.36 938.53,445.36 C937.6,443.89 939.2,442.82 939.2,442.82 C939.959524,442.333035 940.759069,441.911518 941.59,441.56 C942.34,441.16 942.41,440.97 942.41,440.97 C942.557034,440.717851 942.537286,440.401879 942.36,440.17 C941.411423,439.277871 940.875486,438.03218 940.88,436.73 C940.88,433.22 943.59,433.17 943.88,433.17 C944.25,433.17 946.88,433.22 946.88,436.73 C946.884514,438.03218 946.348577,439.277871 945.4,440.17 C945.222714,440.401879 945.202966,440.717851 945.35,440.97 C945.564386,441.237795 945.847958,441.441828 946.17,441.56 C947.001035,441.911299 947.800598,442.332826 948.56,442.82 C948.56,442.82 950.18,443.89 949.25,445.36 Z",
    id: "_Path_8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystemUser);
export default __webpack_public_path__ + "static/media/ecosystem-user.f4842cd790080a498e82afa28c83680b.svg";
export { ForwardRef as ReactComponent };